import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-settings_svg__a"
        d="M22.06 12.017l-.982 4.581h-2.992c-.177.232-.317.41-.447.562l.616 2.836L14.08 22l-1.871-2.37h-.663l-1.874 2.249-4.157-1.996.603-2.774a4.476 4.476 0 01-.505-.623H2.69l-.99-4.622 2.65-1.326c.035-.23.087-.461.157-.684l-1.82-2.306 2.98-3.643L8.28 5.149l.543-.272L9.575 2h4.589l.872 2.867.564.282 2.613-1.244 2.981 3.643-1.874 2.374a97.092 97.092 0 01.136.607l2.604 1.488zm-4.265-.239l-.099-.395c-.05-.198-.088-.366-.174-.754a26.36 26.36 0 00-.163-.706l-.114-.454 1.5-1.9-1.062-1.298-2.103 1.002-2.131-1.066-.7-2.298h-1.7l-.596 2.288L8.3 7.273 6.198 6.271 5.136 7.57l1.585 2.007-.271.543c-.145.29-.236.7-.236 1.033v.59L3.877 12.91l.357 1.667h2.513l.264.527c.18.36.433.676.73.899l.49.367-.531 2.445 1.457.7 1.494-1.794h2.482l1.498 1.897 1.438-.69-.512-2.356.369-.368c.236-.237.446-.498.922-1.133l.286-.382h2.4l.367-1.707-2.106-1.204zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-2c2.205 0 4 1.795 4 4s-1.795 4-4 4-4-1.795-4-4 1.795-4 4-4z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-settings_svg__a"
    />
  </svg>
);
